import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  ImageInput,
  ImageField,
  required,
  useGetList,
} from 'react-admin';
import { useState, useEffect } from 'react';

const spicyLevels = [
  { id: 0, name: 'Не острое' },
  { id: 1, name: 'Слегка острое' },
  { id: 2, name: 'Острое' },
];

const ProductEdit = () => {
  const [categories, setCategories] = useState<Array<{id: number, name: string}>>([]);
  const { data: categoriesData, isLoading, refetch } = useGetList('categories/admin');

  useEffect(() => {
    if (categoriesData) {
      const formattedCategories = categoriesData.map(category => ({
        id: category.id,
        name: category.name
      }));
      setCategories(formattedCategories);
    }
  }, [categoriesData]);

  // Функция для обновления списка категорий
  const refreshCategories = () => {
    refetch();
  };

  return (
    <Edit>
      <SimpleForm>
        <TextInput source="id" disabled />
        <TextInput source="title" label="Название" validate={required()} />
        <SelectInput 
          source="categoryId" 
          label="Категория" 
          choices={categories} 
          validate={required()}
          isLoading={isLoading}
          helperText={
            <span>
              <button 
                type="button" 
                onClick={refreshCategories}
                style={{ marginLeft: '10px', padding: '2px 8px', fontSize: '12px' }}
              >
                🔄 Обновить
              </button>
            </span>
          }
        />
      <TextInput source="description" label="Описание" multiline validate={required()} />
      
      <NumberInput source="price" label="Цена" validate={required()} />
      <NumberInput source="discount" label="Скидка %" min={0} max={100} />
      <NumberInput source="oldPrice" label="Старая цена" />
      
      <TextInput source="weight" label="Вес/Объем" />
      <NumberInput source="calories" label="Калории" />
      <NumberInput source="cookingTime" label="Время приготовления (мин)" />
      
      <ArrayInput source="composition" label="Состав">
        <SimpleFormIterator>
          <TextInput source="" />
        </SimpleFormIterator>
      </ArrayInput>
      
      <ArrayInput source="photos" label="Фото (URL)">
        <SimpleFormIterator>
          <TextInput source="" />
        </SimpleFormIterator>
      </ArrayInput>

      <ImageInput source="newPhotos" label="Загрузить фото" multiple accept={{ 'image/*': [] }}>
        <ImageField source="src" title="title" />
      </ImageInput>
      
      <ArrayInput source="tags" label="Теги">
        <SimpleFormIterator>
          <TextInput source="" />
        </SimpleFormIterator>
      </ArrayInput>
      
      <BooleanInput source="isAvailable" label="Доступен" />
      <BooleanInput source="isVegan" label="Веганский" />
      <SelectInput source="spicyLevel" label="Острота" choices={spicyLevels} />
      </SimpleForm>
    </Edit>
  );
};

export default ProductEdit;